module.exports = __webpack_public_path__ + "media/Video 102.e1881bf7.mp4";